import React, { Component } from 'react';
import 'Styles/loginWindow.scss';
import LoginStore from 'Stores/loginStore';
import { observer } from 'mobx-react';
import { Navigate } from "react-router-dom";
import LoadView from "Components/Common/loadView";
import CheckboxWithText from "Components/Common/CheckboxWithText";
import IconsContainer from 'Utils/IconsContainer'
import AppStore from 'Stores/AppStore';
import Helper from "Utils/Helper";

class LoginWindow extends Component {

    componentDidMount() {
        LoginStore.login = '';
        LoginStore.password = '';

        AppStore.OnMainComponentMount("Авторизация");
        AppStore.GetServiceStateBeforeLogin();
    }

    checkForEnterPress(e) {
        if (e.charCode === 13)
            LoginStore.Login();
    }

    render() {
        if (!this.props.firstPingDone)
            return <LoadView />
        if (!this.props.doesSmrWork)
            return <Navigate to={`${window.SmrLocation}/error`} />

        if (this.props.loggedIn) {
            let params = '';

            for (let paramName in this.props.lastPageInfo.params) {
                if (params === '')
                    params = '?';

                params += `${params.length === 1 ? '' : '&'}${paramName}=${this.props.lastPageInfo.params[paramName]}`;
            }

            return <Navigate to={`${window.SmrLocation}/${this.props.lastPageInfo.pageTitle}${params}${this.props.lastPageInfo.hash}`} />;
        }

        let browserIsOsAuthEnabled = navigator.userAgent.toLowerCase().includes("windows");

        return (
            <div className='login-window-holder'>
                <div className='logo-holder' />
                <div className={"login-window" + (LoginStore.loading ? ' disabled' : '')}>
                    <div className="login-title">
                        <div>
                            Сервер мобильных решений
                        </div>
                        <div>
                            Версия: {this.props.version}
                        </div>
                    </div>
                    <div className="login-body">
                        <div style={{ display: LoginStore.isOsAuth ? "none" : null }}>
                            <div className='field-name'>
                                Имя владельца БД
                            </div>
                            <input onKeyPress={this.checkForEnterPress.bind(this)}
                                onChange={_ => LoginStore.login = event.target.value} />
                        </div>
                        <div style={{ display: LoginStore.isOsAuth ? "none" : null }}>
                            <div className='field-name'>
                                Пароль
                            </div>
                            <div className="password-container">
                                <input type={LoginStore.passwordIsVisible ? "text" : "password"}
                                    onKeyPress={this.checkForEnterPress.bind(this)}
                                    onChange={_ => LoginStore.password = event.target.value} />
                                <div
                                    className={`login-eye ${(Helper.IsBrowserEdge() ? "login-eye-Edge" : "")}`}
                                    onClick={_ => LoginStore.passwordIsVisible = LoginStore.passwordIsVisible == false}>
                                    {IconsContainer.Get(LoginStore.passwordIsVisible ? "login-eye-off" : "login-eye-on")}
                                </div>
                            </div>
                        </div>

                        {(!AppStore.isOsAuthEnabled || !browserIsOsAuthEnabled) ? null : (
                            <div>
                                <CheckboxWithText checked={LoginStore.isOsAuth}
                                    onChange={(checked) => LoginStore.isOsAuth = checked}
                                    text="Аутентификация с помощью ОС"
                                />
                            </div>
                        )}

                        <button className="blue-button"
                            onClick={() => LoginStore.Login()}>Войти</button>
                    </div>
                </div>
            </div>
        )
    }
}

export default observer(LoginWindow);